/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccPicklistOption } from './PccPicklistOption';
import {
    PccPicklistOptionFromJSON,
    PccPicklistOptionFromJSONTyped,
    PccPicklistOptionToJSON,
} from './PccPicklistOption';

/**
 * 
 * @export
 * @interface PccPicklistResponse
 */
export interface PccPicklistResponse {
    /**
     * 
     * @type {Array<PccPicklistOption>}
     * @memberof PccPicklistResponse
     */
    languages?: Array<PccPicklistOption>;
    /**
     * 
     * @type {any}
     * @memberof PccPicklistResponse
     */
    marital_statuses?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PccPicklistResponse
     */
    prefixes?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PccPicklistResponse
     */
    races?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PccPicklistResponse
     */
    suffixes?: any | null;
}

/**
 * Check if a given object implements the PccPicklistResponse interface.
 */
export function instanceOfPccPicklistResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccPicklistResponseFromJSON(json: any): PccPicklistResponse {
    return PccPicklistResponseFromJSONTyped(json, false);
}

export function PccPicklistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPicklistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'languages': !exists(json, 'languages') ? undefined : ((json['languages'] as Array<any>).map(PccPicklistOptionFromJSON)),
        'marital_statuses': !exists(json, 'marital_statuses') ? undefined : json['marital_statuses'],
        'prefixes': !exists(json, 'prefixes') ? undefined : json['prefixes'],
        'races': !exists(json, 'races') ? undefined : json['races'],
        'suffixes': !exists(json, 'suffixes') ? undefined : json['suffixes'],
    };
}

export function PccPicklistResponseToJSON(value?: PccPicklistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'languages': value.languages === undefined ? undefined : ((value.languages as Array<any>).map(PccPicklistOptionToJSON)),
        'marital_statuses': value.marital_statuses,
        'prefixes': value.prefixes,
        'races': value.races,
        'suffixes': value.suffixes,
    };
}

